import React from 'react'
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom'
import {
    WITHHOLDINGS_GENERATION,
    WITHHOLDINGS_LIST,
    INVOICES_ADD,
    INVOICES_LIST
} from 'Constants/Routes'

const ActionButton = ({ icon, title, url = '', tone }) => {
    return (
        <Link to={url} className={`dashboard-quick-action dashboard-quick-action--${tone}`}>
            <span className="dashboard-quick-action__icon" aria-hidden="true">
                <i className={icon} />
            </span>
            <span>{title}</span>
            <i className="fas fa-chevron-right dashboard-quick-action__arrow" aria-hidden="true" />
        </Link>
    )
}

const QuickActions = () => {
    const { t } = useTranslation();

    return (
        <section className="dashboard-quick-actions" aria-label={t('dashboard_quick_actions', { defaultValue: 'Acciones rápidas' })}>
            <ActionButton
                icon="fas fa-plus-circle"
                url={INVOICES_ADD}
                title={t('add_invoice')}
                tone="primary"
            />
            <ActionButton
                icon="fas fa-file-signature"
                url={WITHHOLDINGS_GENERATION}
                title={t('generate_withholding')}
                tone="cyan"
            />
            <ActionButton
                icon="fas fa-file-invoice"
                url={INVOICES_LIST}
                title={t('dashboard_view_invoices', { defaultValue: 'Ver facturas' })}
                tone="indigo"
            />
            <ActionButton
                icon="fas fa-list-alt"
                url={WITHHOLDINGS_LIST}
                title={t('dashboard_view_withholdings', { defaultValue: 'Ver retenciones' })}
                tone="green"
            />
        </section>
    )
}

export default QuickActions